import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

const DateBubble = ({ date }) => (
  <Box display="flex" justifyContent="center" my="1.5rem" width="100%">
    <Typography>{date}</Typography>
  </Box>
);

DateBubble.propTypes = {
  date: PropTypes.string.isRequired,
};

export default DateBubble;
